import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#home', label: '首页' },
  { href: '#categories', label: '类型分类' },
  { href: '#hot', label: '热门推荐' },
  { href: '#collection', label: '大全合集' },
  { href: '#articles', label: '精选文章' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于我们' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 transition-colors duration-300 nav-scrolled">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap" aria-label="妖精漫画大全首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-paper-50">
            <i className="ri-ghost-2-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-serif text-lg font-bold tracking-wide text-ink-900">
            妖精<span className="text-primary-500">漫画大全</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-ink-600 transition-colors hover:bg-primary-50 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#collection"
            className="whitespace-nowrap rounded-full border border-primary-300 px-5 py-2 text-sm text-primary-600 transition-colors hover:bg-primary-50"
          >
            看合集
          </a>
          <a
            href="#hot"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-paper-50 transition-colors hover:bg-primary-600"
          >
            立即开看
          </a>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-ink-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-paper-200 bg-paper-50 px-4 py-4 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-sm text-ink-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#hot"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-3 text-center text-sm text-paper-50"
            >
              立即开看
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}